import React from "react";
import { Redirect, Route } from "react-router-dom";
import { AuthRepository } from "ftl-auth-module";
export default ({ path, exact, children }) => {
    return AuthRepository.tokens.accessToken ? (React.createElement(Route, { exact: exact, path: path }, children)) : (React.createElement(Redirect, { to: "/" }));
};
//# sourceMappingURL=PrivateRoute.js.map